import {anyArray, dataMember, required, typedArray} from 'santee-dcts';

export class EQueryAdminSummary {
    @dataMember()
    @required()
    public eQueryId: number;

    @dataMember()
    @required()
    public accessionNumber: string;

    @dataMember()
    @required({ nullable: true })
    public subjectNumber: string;

    @dataMember()
    @required({ nullable: true })
    public subjectId: string;

    @dataMember()
    @required({ nullable: true })
    public initials: string;

    @dataMember()
    @required()
    public protocolName: string;

    @dataMember()
    @required({ nullable: true })
    public visitName: string;

    @dataMember()
    @required({ nullable: true })
    public protocolVisitCode: string;

    @dataMember()
    @required({ nullable: true })
    @anyArray()
    public responders: string[];

    @dataMember()
    @required()
    public isHidden: boolean;
}

export class EQueryAdminSummariesReadModel {
    @dataMember()
    @required()
    @typedArray(EQueryAdminSummary)
    public eQueries: EQueryAdminSummary[];
}